<script setup>

import Breadcrumbs from "~/components/organisms/Breadcrumbs.vue";
import Heading from "~/components/atoms/Heading.vue";
import Text from "~/components/atoms/Text.vue";
import ArticlesGrid from "~/components/organisms/ArticlesGrid.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import {useRoute} from 'vue-router';
import { fetchWithErrorHandling } from '~/composables/fetchWithErrorHandling';

import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t } = useI18n();

const page = ref(parseInt(route.query.page, 10) || 1)


const data = await fetchWithErrorHandling(`/blog/`, {
  lazy: false,
  query: {page: page.value}
})

useHead({
  title: 'Blogg',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: t('blog.sub_title')
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      children: data.value.breadcrumbs_structured_data
    },
  ]
})

const articlesList = ref([...(data.value?.articles || [])]);
const loading = ref(false);

const total = computed(() => data.value ? data.value.total : 0);
const per_page = computed(() => data.value ? data.value.per_page : 0);
const current_page = computed(() => data.value ? data.value.current_page : 1);
const pages_count = computed(() => data.value ? data.value.pages_count : 1);

const fetchBlogData = async (newPage, append = false) => {
  if (!append) loading.value = false;
  
  const newData = await fetchWithErrorHandling(`/blog/`, {
     lazy: false,
     query: {page: newPage}
  });

  if (newData.value) {
    if (append) {
      articlesList.value = [...articlesList.value, ...(newData.value.articles || [])];
    } else {
      articlesList.value = [...(newData.value.articles || [])];
      window.scrollTo(0, 0);
    }
    data.value = newData.value;
    page.value = newPage;
    
    if (process.client) {
      const url = new URL(window.location);
      url.searchParams.set('page', newPage);
      window.history.replaceState(null, '', url);
    }
  }
};

const handlePageChange = (newPage) => {
  fetchBlogData(newPage, false);
};

const loadMore = async (newPage) => {
  loading.value = true;
  await fetchBlogData(newPage, true);
  loading.value = false;
};

</script>

<template>
  <div class="container" style="gap: 26px;">
    <Breadcrumbs :breadcrumbs="[{title:'Hill Ceramic',url:''},{title:'Inspiration',url:'blogg/'}]"/>

    <header>
      <Heading align="center" tag="h1" font-size="36px">Inspiration</Heading>
    </header>

    <Text class="sub-title" text-alignment="center">{{ $t('blog.sub_title') }}</Text>

    <ArticlesGrid :articles="articlesList"/>

    <Pagination @change="handlePageChange" entity="article" :current-page="current_page"
                :count="articlesList.length"
                :loading="loading"
                :load-more="true"
                @more="loadMore"
                :items-per-page="per_page" :total-items="total"
                :total-pages="pages_count"/>
  </div>
</template>

<style scoped lang="scss">
.sub-title {
  font-size: 12px;
  max-width: 1000px;
  margin: 0 auto;
  color: $light-black;
}
</style>
